export default "__VITE_ASSET__ZdbXYw6QRX2rvRlorMJdGQ__";